// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Button, ListGroup, ListGroupItem } from "reactstrap";
import TableWithSortPagtn from "../../common/TableWithSortPagtn";
import DropDownActions from "../../common/DropDownActions";
import moment from 'moment';
const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let maxwidth="80vw";
const ListMyLeave = React.memo(
  ({

    empTask,
    handleToggleAllTaskCalendar,
  }) => {
    const [thead] = useState([
      "Type",
      "AllowedPerYear",
      "LeaveBalance",
      "TakenLeave",
      "CarryForwarded",

    ]);
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
    const [leavelist,setleavelist]=useState([]);




   useEffect(() => {
    const hh=empTask;
    if(empTask.length>0){
      let trow = empTask.map((el) => ({
        Type:<div style={{width:'300px'}}>{el.type}</div>,
        AllowedPerYear:<div style={{width:'100px'}}>{el.noOfLeavesPerYear}</div>,
        LeaveBalance:<div style={{width:'100px'}}>{el.leaveBalance}</div>,
        TakenLeave:<div style={{width:'100px'}}>{el.takenLeave == null ? (0) :(el.takenLeave)}</div>,
        CarryForwarded:<div style={{width:'100px'}}>{el.noOfLeavesCarryForwarded}</div>,
      
      }));

      setTrow(trow);
    }
    }, []);
    
    return (
      <Fragment>
        <div className="fixed-header">
          <div>
            {/* <Button
              size="sm"
              outline
              className="secondary"
              onClick={() => handleAddEditTaskForm("add")}
            >
              Add Task
            </Button> */}
            &nbsp;
          
            <div className="d-inline float-right ">
            {/* <Button
              size="sm"
              outline
              className="secondary"
              onClick={handleUnlockRequestForm}
            >
              Request Unlock
            </Button> */}
              {/* <Button color="" onClick={handleOpenCalendar}>
                <i className="fas fa-calendar-day text-muted"></i>
              </Button> */}
              {/* <Button color="" onClick={handleToggleAllTaskCalendar}>
                <i className="fas fa-calendar-alt text-muted"></i>
              </Button> */}
            </div>
          </div>
        </div>
        <div className="" style={{ maxWidth: maxwidth, overflowY: "auto" }}>
      <TableWithSortPagtn thead={thead} trow={trow} pageSize={10}></TableWithSortPagtn>
    </div>
        {/* <div className="mt-3">
          <ListGroup className="task-list ">
            {empTask.map((tasks, i) => (
              <ListGroupItem
                key={i}
                onClick={() => handleOnclickSelectedTask(tasks, i)}
                style={i === activeTask ? active : null}
              >
                <div className="task-container ">
                  <span className="task-check">
                  {tasks.timeSheetStatus ==3 ? (<i className="fas fa-check  project-task-icon" style={{ color: 'green'}}></i>) : <i className="fas fa-check  project-task-icon"></i>}
                    
                  </span>
                  <span className="task-label">{tasks.description}</span>
                  <span className="task-label">{tasks.hoursSpent}</span>
                  <span className="task-label">{tasks.timeSheetStatus}</span>
                  <span className="task-action-btn task-btn-right">
                    <span
                      className="action-circle large task-assign"
                      title="Assign"
                    >
                      <i className="fas fa-user  project-task-icon"></i>
                    </span>
                    <span
                      className="action-circle large delete-btn"
                      title="Delete Task"
                      onClick={() => DelTask(tasks.employeeTimeSheetId)}
                    >
                      <i className="fas fa-trash project-task-icon"></i>
                    </span>
                  </span>
                </div>
              </ListGroupItem>
            ))}
          </ListGroup>
        </div> */}
      </Fragment>
    );
  }
);

export default ListMyLeave;
